import { t } from '@ui/lib/i18n'

/** Wagmi's unsupported-switch error, or the provider response wrapped by Viem. */
export const isUnsupportedChainError = (error: unknown): boolean => {
  const outer = error as Error | undefined
  const provider = outer?.name === 'SwitchChainError' ? (outer.cause as Error | undefined) : outer
  return (
    outer?.name === 'SwitchChainNotSupportedError' ||
    (provider?.name === 'Provider.UnsupportedMethodError' &&
      /^wallet_switchEthereumChain::chainId 0x[\da-f]+ not supported$/i.test(provider.message))
  )
}

type CustomError = { data?: { message: string }; code?: string } & Error

/**
 * TODO: this function was deduplicated from four different apps into ui for FormAlerts.tsx, but it's rather ugly.
 * A future PR will need to properly get error messages and dedupe the whole AlertFormError.tsx shebang.
 */
export function getErrorMessage(e: unknown, defaultErrorMessage?: string): string {
  let errorMessage = defaultErrorMessage ?? ''

  const error = e as CustomError
  if (error?.message) {
    if (error.message.toLocaleLowerCase().includes('user rejected') || error?.code === 'ACTION_REJECTED') {
      errorMessage = t`User rejected transaction`
    } else if (error.message.toLocaleLowerCase().includes('bad swap type')) {
      errorMessage = t`Swap route is not available on Curve. Try an aggregator.`
    } else if ('data' in error && typeof error.data?.message === 'string') {
      errorMessage = error.data.message
    } else {
      errorMessage = error.message
    }
  }
  return errorMessage
}

/**
 * Browser auto-translation/extensions can mutate the DOM and break React reconciliation.
 * This usually surfaces as a NotFoundError for Node.removeChild.
 */
const isDomRemoveChildMutationError = (error: unknown): boolean =>
  error instanceof Error && error.message.includes('removeChild') && error.message.includes('not a child of this node')

export const getBoundaryErrorSubtitle = (error: unknown, fallback: string): string =>
  isDomRemoveChildMutationError(error)
    ? [
        t`The page changed unexpectedly and can no longer update safely.`,
        t`Please refresh the page and try again.`,
        t`Disable your browser plugins if the issue persists.`,
      ].join(' ')
    : error instanceof Error && error.message
      ? error.message
      : fallback
